import { EasingGraph, fixedFactory, set } from "@porkchopsandwich/easers";

export const lockedEaser = (easer: EasingGraph, frontLock = 0.1, endLock = 0.9): EasingGraph => {
    return set([fixedFactory(0), 0, frontLock], [easer, frontLock, endLock], [fixedFactory(1), endLock, 1]);
};
